import React from 'react';
import { experience } from '../data/portfolioData';
import './Experience.css';

function TimelineItem({ item }) {
  return (
    <div className="tl-item">
      <div className="tl-dot" style={{ background: item.dotColor }} />
      <div className="tl-meta">
        <span className="tl-date">{item.period}</span>
        <span className="tl-co" style={{ background: item.badgeColor.bg, color: item.badgeColor.color }}>
          {item.company}
        </span>
        {item.current && <span className="tl-badge">Current</span>}
        {item.badge && (
          <span className="tl-badge" style={{ background: 'rgba(245,158,11,0.12)', color: '#D97706' }}>
            {item.badge}
          </span>
        )}
      </div>
      <div className="tl-role">{item.role}</div>
      <div className="tl-desc">{item.desc}</div>
      <div className="tl-skills">
        {item.skills.map(s => (
          <span key={s} className="tl-skill">{s}</span>
        ))}
      </div>
    </div>
  );
}

export default function Experience() {
  return (
    <section id="experience">
      <div className="section-label">Experience &amp; Education</div>
      <h2 className="section-title">My Journey</h2>
      <p className="section-sub">
        From Bronze Medal graduate to shipping AI-powered blockchain systems in production.
      </p>

      <div className="timeline">
        {experience.map(item => (
          <TimelineItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}
